<template>
  <chart-overwrite-modal-base
    v-if="cashDeskPriceOverwriteMetadata.cashDeskPriceObj"
    ref="baseModal"
    :form-data="cashDeskPriceOverwriteMetadata"
    :modal-id="cashDeskPriceOverwriteMetadata.cashDeskPriceObj.id"
    :edit-date="cashDeskPriceOverwriteMetadata.cashDeskPriceObj.date"
    @overwrite="overwrite"
  >
    <template #title>{{ title }} </template>

    <template #help>
      <v-row>
        <v-col> Nothing here yet </v-col>
      </v-row>
    </template>

    <template #body>
      <v-row class="no-gutters font-weight-light">
        <v-col cols="8" class="border-bottom-gray">
          {{ $t('cashDaskPriceModal.currentPrice') }}
        </v-col>
        <v-col cols="4" class="border-bottom-gray">
          {{ cashDeskPriceOverwriteMetadata.cashDeskPriceObj.price | currency }}
        </v-col>

        <v-col cols="8" class="border-bottom-primary">
          {{ $t('cashDaskPriceModal.difference') }}
        </v-col>
        <v-col cols="4" class="border-bottom-primary">
          {{
            (newCashDeskPrice -
              cashDeskPriceOverwriteMetadata.cashDeskPriceObj.price)
              | currency
          }}
        </v-col>
        <v-col cols="8">
          {{ $t('cashDaskPriceModal.newPrice') }}
        </v-col>
        <v-col cols="4">
          {{ newCashDeskPrice | currency }}
        </v-col>
      </v-row>

      <override-slider
        :sliderValue="newCashDeskPrice"
        :sliderStepSize="sliderStepSize"
        :decimals="2"
        :power="2"
        :minValue="1"
        :maxValue="cashDeskPriceOverwriteMetadata.max * 2"
        :currency="$store.getters.getCurrentDestinationInstance().getCurrency()"
        :minTitle="$t('cashDaskPriceModal.min')"
        :maxTitle="$t('cashDaskPriceModal.max')"
        @updateSliderValue="newCashDeskPrice = $event"
      ></override-slider>
    </template>
  </chart-overwrite-modal-base>
</template>

<script>
import Vue from 'vue'
import CashDeskPriceService from '@/classes-internal/cashDeskPrice/CashDeskPriceService'
import ChartOverwriteModalBase from '@/components-internal/charts/ChartOverwriteModalBase'
import OverwriteModalMixin from '@/components-internal/mixins/OverwriteModalMixin'
import OverrideSlider from './OverrideSlider'

export default Vue.extend({
  name: 'CashDeskPricesChartOverwriteModal',

  components: { ChartOverwriteModalBase, OverrideSlider },

  mixins: [OverwriteModalMixin],

  props: {
    cashDeskPriceOverwriteMetadata: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      newCashDeskPrice: null,
      service: new CashDeskPriceService(),
      sliderStepSize: 1,
    }
  },

  computed: {
    title() {
      return (
        this.$i18n.t('cashDaskPriceModal.title') +
        ' ' +
        this.$options.filters.formatDate(
          this.cashDeskPriceOverwriteMetadata.cashDeskPriceObj.date
        )
      )
    },
  },

  watch: {
    cashDeskPriceOverwriteMetadata: {
      handler: function (newVal) {
        if (newVal.cashDeskPriceObj) {
          this.newCashDeskPrice = newVal.cashDeskPriceObj.price
        }
      },
      deep: true,
    },
  },

  methods: {
    open() {
      this.$refs.baseModal?.openModal()
    },
    async overwrite() {
      await this.service.overwrite(
        this.cashDeskPriceOverwriteMetadata.cashDeskPriceObj,
        this.newCashDeskPrice
      )
      this.showModal = false
      this.$emit('updated')
    },
    // TODO:
    // async reset() {
    //   await this.service.reset(
    //     this.cashDeskPriceOverwriteMetadata.cashDeskPriceObj
    //   )
    //   this.showModal = false
    //   this.$emit('updated')
    // },
  },
})
</script>
